import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-start',
  height: theme.typography.pxToRem(800),
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  padding: theme.spacing(8, 0),
  [theme.breakpoints.down('xl')]: {
    height: theme.typography.pxToRem(710),
  },
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(3, 0),
  },

  '& .OPSOverlay': {
    background: `linear-gradient(358deg, ${theme.palette.background.default} 6.47%, ${theme.palette.divider[1]} 59.97%, rgba(17, 17, 17, 0.00) 98.48%)`,
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: theme.spacing(-0.25),
    zIndex: 1,
  },
  '& .ORSVideo, .IBimgbox': {
    position: 'absolute !important',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    objectFit: 'cover',
    zIndex: 0,
    width: '100%',
    height: '100%',
  },
  '& .OPSContent': {
    position: 'relative',
    zIndex: 2,
    maxWidth: theme.typography.pxToRem(640),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'self-start',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
    },
  },
}));

export default StyledBox;
